import { DatePicker } from 'antd';
import { RangePickerProps } from 'antd/lib/date-picker';

import styles from './index.module.scss';

export const CommonRangePicker = (props: RangePickerProps) => {
  return (
    <DatePicker.RangePicker
      {...props}
      className={`${styles.rangePicker} ${props.className || ''}`}
    />
  );
};
